
export const messages = {
    cn: {
        allCountry: '全部数据库',
        ip5: '知识产权五局',
        major: '主要受理局',
        others: '其他受理局',
        filterCountry: '查找受理局',
        leastOne: '至少选择一项',
        filterNoData: '暂无数据',
    },
    en: {
        allCountry: 'All databases',
        ip5: 'IP 5',
        major: 'Main Authority',
        others: 'Other Authority',
        filterCountry: 'Filter by authority',
        leastOne: 'Select at least one',
        filterNoData: 'No data available',
    },
    jp: {
        allCountry: '全データベース',
        ip5: '知的財産権５局',
        major: '主要な受理官庁',
        others: 'その他受理官庁',
        filterCountry: '受理官庁の検索',
        leastOne: '少なくとも 1 つ選択してください',
        filterNoData: 'データはありません',
    },
    tw: {
        allCountry: '全部數據庫',
        ip5: '知識產權五局',
        major: '主要受理局',
        others: '其他受理局',
        filterCountry: '查找受理局',
        leastOne: '至少選擇一項',
        filterNoData: '暫無數據',
    },
}
